import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import { getAuth, onAuthStateChanged } from "firebase/auth";
import createCustomReport from './create-custom-report';
import assetFilters from './asset-filters';

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
    key: 'vuex', // The key to store the state on in the storage provider.
    storage: window.localStorage, // or window.sessionStorage or localForage
    reducer: (state) => ({
        // Only persist the `user` state to localStorage, excluding `createCustomReport`
        user: state.user,
        connected: state.connected
    })
});

export default new Vuex.Store({
    modules: {
        createCustomReport, // Keep this module but it will not be persisted
        assetFilters
    },
    state: {
        connected: navigator.onLine,
        user: {
            loggedIn: false,
            data: null,
            auth: null,
            authToken:  null,
        }
    },
    getters: {
        user(state) {
            return state.user
        },
        connected(state) {
            return state.connected
        }
    },
    mutations: {
        SET_LOGGED_IN(state, value) {
            state.user.loggedIn = value;
        },
        SET_USER(state, data) {
            state.user.data = data;
        },
        SET_AUTH(state, data) {
            state.user.auth = data;
        },
        SET_CONNECTED(state, payload) {
            state.connected = payload
        },

        SET_AUTH_TOKEN(state, payload) {
            state.user.authToken = payload
        }
    },
    actions: {
        setConnected ({ commit }, payload) {
            commit('SET_CONNECTED', payload)
        },
        fetchUser({ commit }, user) {
            commit("SET_LOGGED_IN", user !== null);
            if (user) {
                commit("SET_USER", user)
                const auth = getAuth();
                //commit("SET_AUTH", auth.currentUser);
                onAuthStateChanged(auth, (firebaseUser) => {
                    if (firebaseUser) {
                        // User is signed in, see docs for a list of available properties
                        // https://firebase.google.com/docs/reference/js/auth.user
                        commit("SET_AUTH", {
                            ...auth.currentUser
                        });
                    } else {
                        commit("SET_USER", null);
                        commit("SET_AUTH", null);
                        commit("SET_AUTH_TOKEN", null);
                    }
                });
            } else {
                commit("SET_USER", null);
                commit("SET_AUTH", null);
                commit("SET_AUTH_TOKEN", null);
            }
        }
    },
    plugins: [vuexLocalStorage.plugin]
});
